var _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _path3, _circle6, _circle7, _circle8, _circle9, _circle0, _line, _line2, _circle1, _circle10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNeu2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 153,
    viewBox: "0 0 153 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.7742 32.6639C86.8206 20.5762 79.2557 27.4889 77.0005 33.4275C69.6035 27.1133 62.0142 33.3484 64.0005 38.752C55.4308 39.8795 57.5003 49.4277 61.8784 51.3814C56.1052 54.9896 59.6235 64.0103 67.0653 62.2062C66.5005 68.9275 72.0005 69.4275 76.086 65.1379C81.5005 73.9277 88.0005 70.9277 90.519 65.1379C94.4881 70.9111 101.118 67.167 101.569 63.1077C112 65.9277 111 56.4277 109.011 53.185C116 44.9277 111.793 39.203 104.727 38.752C106.531 26.8447 96.9087 29.4313 92.7742 32.6639Z",
    fill: "#52537A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9954 127.83H63.7954C67.6588 127.83 70.7908 124.698 70.7908 120.834V116.332C70.7908 114.899 70.3599 113.493 69.3731 112.453C67.1642 110.126 62.4577 106.206 55.844 106.24C49.2416 106.274 44.5906 110.154 42.4071 112.459C41.4265 113.495 41 114.895 41 116.321V120.834C41 124.698 44.132 127.83 47.9954 127.83Z",
    fill: "#9157B3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55.8958,
    cy: 96.4114,
    r: 11.8801,
    fill: "#9157B3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.1068,
    cy: 94.8431,
    r: 3.07557,
    fill: "#F1F1F1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.1068,
    cy: 94.8431,
    r: 3.07557,
    fill: "#F1F1F1"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.3236,
    cy: 94.8431,
    r: 3.07557,
    fill: "#F1F1F1"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.3236,
    cy: 94.8431,
    r: 3.07557,
    fill: "#F1F1F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0526 57.8957H80.9474C82.6333 57.8957 84 56.529 84 54.843V52.8786C84 52.2531 83.812 51.6393 83.3813 51.1857C82.4174 50.1704 80.3636 48.4598 77.4776 48.4747C74.5964 48.4895 72.5668 50.1823 71.614 51.1884C71.1861 51.6403 71 52.2512 71 52.8735V54.843C71 56.529 72.3667 57.8957 74.0526 57.8957Z",
    fill: "#9157B3"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.5006,
    cy: 44.1842,
    r: 5.18421,
    fill: "#9157B3"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.973,
    cy: 43.5003,
    r: 1.34211,
    fill: "#F1F1F1"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.973,
    cy: 43.5003,
    r: 1.34211,
    fill: "#F1F1F1"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.8675,
    cy: 43.5003,
    r: 1.34211,
    fill: "#F1F1F1"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.8675,
    cy: 43.5003,
    r: 1.34211,
    fill: "#F1F1F1"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 90.7499,
    y1: 52.5546,
    x2: 99.1514,
    y2: 44.1532,
    stroke: "#D48485",
    strokeWidth: 2.3977
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 90.8477,
    y1: 44.1523,
    x2: 98.8401,
    y2: 52.1446,
    stroke: "#D48485",
    strokeWidth: 2.3977
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.0743,
    cy: 76.6387,
    r: 2.93171,
    fill: "#52537A"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.9554,
    cy: 82.9535,
    r: 2.02965,
    fill: "#52537A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeu2);
export default __webpack_public_path__ + "static/media/neu-2.cc47345e54a99e16da68d2349b5237f2.svg";
export { ForwardRef as ReactComponent };